

import React, { useEffect, useRef, useState } from "react";
import { Link as RouterLink, useSearchParams, useParams, useNavigate } from 'react-router-dom';

// material
import { styled } from '@mui/material/styles';
import {
  Box, MenuItem, Typography, InputAdornment,
  Table,
  Card,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  Button,
  TableRow,
  InputLabel,
  FormControl,
  Stack,
  Checkbox,
  Select,
  Divider,
  TextField,
  LinearProgress
} from '@mui/material';

import "../css/GlobalStyles.css";
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';

import { APP_CONSTANTS } from '../URLConstants'
import { isoDateFormatInDmyhs, isoDateFToNow } from '../utils/formatTime';
import { showFieldValueWithCheck, showLanguageLabelUsingCode, crossMarkString, crossMarkDeviceIdString } from '../utils/Utilities'


// components
import Page from '../components/Page';
import { ActivateDeviceModal, SoundBoxDeviceMoreMenu, TestSoundBoxPaymentModal } from "../components/_dashboard/soundbox";
import { useAuth } from "../components/customContextProviders/AuthContext";

import { GetAllDevicesWithTrans } from '../network/Device'





// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  paddingTop: theme.spacing(15),
  paddingBottom: theme.spacing(10)
}));


const columns = [
  { field: 'merchantId', headerName: ' Merchant ID', width: 120 },
  { field: 'deviceId', headerName: 'Device Id', width: 120 },
  { field: 'status', headerName: 'Status', width: 120 },
  { field: 'lastTrans', headerName: 'Last Trans.', width: 120, },
  { field: 'rentStatus', headerName: 'Rent Status', width: 120, },
  { field: 'onboardingChannel', headerName: 'Onboarding Channel', width: 150, },
  { field: 'zone', headerName: 'Zone', width: 120, },
  { field: 'lastUpdated', headerName: 'Last Updated', width: 120, },
  { field: 'simNumber', headerName: 'Sim Number', width: 120, },
  {
    field: 'language', headerName: 'Language', width: 120,
    valueGetter: (params) =>
      `${showLanguageLabelUsingCode(params?.row?.language) || ''}`
  },
  { field: 'campaign', headerName: 'Campaign', width: 120, },
  { field: 'battery', headerName: 'Battery', width: 120, },
  { field: 'message_received', headerName: 'Message Received', width: 150, },
  { field: 'notification_missed', headerName: 'Notification Missed', width: 150, },
  { field: 'reboot_count', headerName: 'Reboot Count', width: 120, },
  { field: 'installation_date', headerName: 'Installation Date', width: 150, },
  { field: 'fw_version', headerName: 'FW Version', width: 120, },
];

let currentPage = 1
let isHasDeviceDataHasNextPage = true;


export default function SoundBoxDevicesListBuilder({ _soundboxDeviceListData }) {

  const navigate = useNavigate();
  const { sessionUserData, organizationAudioCubeTerritories, audioCubeAppLevelSettings } = useAuth()

  const [organizationSelectedZone, setOrganizationSelectedZone] = useState("")
  const [devicesList, setDevicesList] = useState([])
  const [devicesListLoading, setDevicesListLoading] = useState(false);
  const [isTestSoundBoxModalOpen, setIsTestSoundBoxModalOpen] = useState(false)
  const [isActivateDeviceModalOpen, setIsActivateDeviceModalOpen] = useState(false)
  const [locationFilterVal, setLocationFilterVal] = useState('');
  const [languageFilterVal, setLanguageFilterVal] = useState("")
  const [searchByVal, setSearchByVal] = useState("")
  const [selectedDeviceIdForTestPaymnt, setSelectedDeviceIdForTestPaymnt] = useState("")

  const [selectedDevicesList, setSelectedDevicesList] = useState([]);
  const deviceTableRef = useRef(null);

  const [openAlertDialog, setOpenAlertDialog] = useState(false)
  const [alertDialogMetas, setAlertDialogMetas] = useState({
    message: "",
    title: "",
    btnLabel: "",

  });


  useEffect(() => {
    fetchDevices(sessionUserData?.user?.role === APP_CONSTANTS.USER_ROLE_SUPER_ADMIN ? "" : sessionUserData?.user?.organization?.id, "", languageFilterVal, searchByVal, currentPage, 10, "LOAD")
    return () => {
      currentPage = 1;
      isHasDeviceDataHasNextPage = true
      setDevicesList([])
    }
  }, []);

  const handleScroll = () => {
    const card = deviceTableRef.current;

    if (card) {
      const scrollPercentage = (card.scrollTop / (card.scrollHeight - card.clientHeight)) * 100;

      if (scrollPercentage > 80 && isHasDeviceDataHasNextPage) {
        if (!devicesListLoading) {
          /* eslint-disable */
          currentPage = currentPage + 1
          /* eslint-enable */
          fetchDevices(sessionUserData?.user?.role === APP_CONSTANTS.USER_ROLE_SUPER_ADMIN ? "" : sessionUserData?.user?.organization?.id, "", languageFilterVal, searchByVal, currentPage, 10, "LOAD")

        }

      }
    }

  };


  function fetchDevices(organizationId, location, language, searchBy, pageNo, limit, type) {

    setDevicesListLoading(true)

    GetAllDevicesWithTrans(pageNo, limit, organizationId, location, language, searchBy).then((res) => {
      setDevicesListLoading(false)
      isHasDeviceDataHasNextPage = res?.data?.data?.hasNextPage

      if (type === 'LOAD')
          setDevicesList(prevList => [...prevList, ...(res?.data?.data?.lists ?? [])]);

      else if (type === 'SEARCH'){
        setDevicesList([]);
        setDevicesList(res?.data?.data?.lists ?? []);
      }
       
    }).catch((_error) => {
      setDevicesListLoading(false)

    })


  }




  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = devicesList?.map((row) => row?.deviceid);
      setSelectedDevicesList(newSelected);
    } else {
      setSelectedDevicesList([]);
    }
  };

  const handleRowSelectClick = (_event, id) => {
    const selectedIndex = selectedDevicesList.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedDevicesList, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedDevicesList.slice(1));
    } else if (selectedIndex === selectedDevicesList.length - 1) {
      newSelected = newSelected.concat(selectedDevicesList.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedDevicesList.slice(0, selectedIndex),
        selectedDevicesList.slice(selectedIndex + 1)
      );
    }
    setSelectedDevicesList(newSelected);
  };
  const isSelected = (id) => selectedDevicesList.indexOf(id) !== -1;


  const handleOrganizatioZoneValChange = (event) => {
    setOrganizationSelectedZone(event.target.value)
  }

  const handleLocationFilterValChange = (event) => {
    setLocationFilterVal(event.target.value);

  };

  const handleLanguagueFilterValChnage = (event) => {
    setLanguageFilterVal(event.target.value)
    currentPage = 1;
    fetchDevices(sessionUserData?.user?.role === APP_CONSTANTS.USER_ROLE_SUPER_ADMIN ? "" : sessionUserData?.user?.organization?.id, "", event.target.value, searchByVal, currentPage, 10, "SEARCH")

  }

  const handleSearchByValChange = (event) => {
    setSearchByVal(event?.target?.value)
    currentPage = 1;
    fetchDevices(sessionUserData?.user?.role === APP_CONSTANTS.USER_ROLE_SUPER_ADMIN ? "" : sessionUserData?.user?.organization?.id, "", languageFilterVal, event?.target?.value, currentPage, 10, "SEARCH")

  }

  function getColorAccordingSevertity(battery) {
    if (battery !== null && battery !== undefined) {
      if (battery >= 80)
        return "#0DA626";
      if (battery > 30 && battery < 80)
        return "#FF9900";
      if (battery < 30)
        return "#C30A0A";
    }
    return "#ddd"
  }

  const handleUserMoreMenuClick = (action, deviceData) => {
    switch (action) {
      case "assign_vehicle": {
        setSelectedDeviceIdForTestPaymnt(deviceData?.id)
        setIsTestSoundBoxModalOpen(true)
        break;
      }
      case "activate_device": {
        setSelectedDeviceIdForTestPaymnt(deviceData)
        setIsActivateDeviceModalOpen(true)
        break
      }
      default: {
        return ""
      }
    }
  }


  function onAddDeviceModalAction(d) {
    alert(d)
  }

  function onTestSoundBoxPaymentModalAction(_d) {
  }





  return (
    <Box>
      <Box sx={{ width: '100%', }}>
        <Card sx={{ width: "100%" }}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ pl: 3, pr: 3, pt: 2, pb: 2 }} mt={1} mb={1}>
            <Stack direction="row" spacing={2} alignItems="center" justifyContent="flex-start" >
              <Typography sx={{ fontSize: 16, fontWeight: 'bold' }}>
                Filter By
              </Typography>
              {/* <FormControl size="small" sx={{ minWidth: 120 }}>
                <InputLabel id="location-select-label">Location</InputLabel>
                <Select
                  labelId="location-select-label"
                  id="location-select"
                  value={locationFilterVal}
                  label="Location"
                  onChange={handleLocationFilterValChange}
                >
                  <MenuItem value={"ALL"}>ALL</MenuItem>
                  <MenuItem value={"Nagpur"}>Nagpur</MenuItem>
                  <MenuItem value={"Delhi"}>Delhi</MenuItem>
                  <MenuItem value={"Jaipur"}>Jaipur</MenuItem>

                </Select>
              </FormControl> */}

              {/* <FormControl size="small" sx={{ minWidth: 150 }}>
                <InputLabel id="device-select-label">Zone </InputLabel>
                <Select
                  labelId="device-select-label"
                  id="device-select"
                  value={organizationSelectedZone}
                  onChange={handleOrganizatioZoneValChange}
                  label="Zone">
                  <MenuItem value="">ALL</MenuItem>
                  {
                    organizationAudioCubeTerritories?.filter(obj=>obj?.parent_id==="0")?.map((row) => (
                      <MenuItem value={row?.id} sx={{ p: 1.5 }}>{row?.name}</MenuItem>
                    ))
                  }

                </Select>
              </FormControl> */}

              {
                audioCubeAppLevelSettings?.language !== null && audioCubeAppLevelSettings?.language !== undefined &&
                  Object.keys(audioCubeAppLevelSettings?.language).length !== 0 ?


                  <FormControl size="small" sx={{ minWidth: 120 }}>
                    <InputLabel id="language-filter-select-label">Language </InputLabel>
                    <Select
                      labelId="language-filter-select-label"
                      id="language-filter-select"
                      value={languageFilterVal}
                      label="Language "
                      onChange={handleLanguagueFilterValChnage}
                    >
                      <MenuItem value="" sx={{ p: 1.5 }}>  ALL</MenuItem>
                      {
                        Object.entries(audioCubeAppLevelSettings?.language)?.map(([key, value]) => (
                          <MenuItem key={key} value={key} sx={{ p: 1.5 }}>{value}</MenuItem>
                        ))
                      }

                    </Select>
                  </FormControl>
                  :
                  null
              }

              <FormControl size="small" sx={{ minWidth: 120 }}>
                <TextField
                  size="small"
                  label="Search"
                  placeholder="Search"
                  onChange={handleSearchByValChange}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchOutlinedIcon />
                      </InputAdornment>
                    ),
                  }}

                />
              </FormControl>


            </Stack>

            <Stack direction="row" spacing={2} alignItems="center" justifyContent="flex-end" >


              <Button variant="contained" className="secondayDashboardButton" size="small" sx={{ mr: 1, minHeight: '5vh', minWidth: 110 }}  >SMS</Button>
            </Stack>
          </Stack>
          <Divider sx={{ m: 1 }} />


          {/* <div style={{  width: '100%' }}>
              <DataGrid
                rows={smartLockDeviceListData}
                columns={columns}
                disableColumnFilter={true}
                disableColumnSort={true}
                pagination={false} 
                pageSize={smartLockDeviceListData.length}
                checkboxSelection
              />
        </div> */}


          <TableContainer sx={{ maxHeight: 500, overflowY: 'scroll' }} ref={deviceTableRef} onScroll={handleScroll}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell padding="checkbox" sx={{ minWidth: '5vw' }}>
                    <Checkbox
                      checked={selectedDevicesList.length === devicesList?.length}
                      onChange={handleSelectAllClick}
                    />
                  </TableCell>
                  <TableCell align="center" sx={{ minWidth: '8vw', fontWeight: 900 }}>Merchant Id</TableCell>
                  <TableCell align="center" sx={{ minWidth: '8vw', fontWeight: 900 }}>Device Id</TableCell>
                  <TableCell align="center" sx={{ minWidth: '8vw', fontWeight: 900 }}>Status</TableCell>
                  <TableCell align="center" sx={{ minWidth: '8vw', fontWeight: 900 }}>Last Trans</TableCell>
                  <TableCell align="center" sx={{ minWidth: '8vw', fontWeight: 900 }}>Rent Status</TableCell>
                  <TableCell align="center" sx={{ minWidth: '10vw', fontWeight: 900 }}>Onboarding Channel</TableCell>
                  <TableCell align="center" sx={{ minWidth: '11vw', fontWeight: 900 }}>Zone</TableCell>
                  <TableCell align="center" sx={{ minWidth: '10vw', fontWeight: 900 }}>Last Updated</TableCell>
                  <TableCell align="center" sx={{ minWidth: '8vw', fontWeight: 900 }}>Sim Number</TableCell>
                  <TableCell align="center" sx={{ minWidth: '8vw', fontWeight: 900 }}>Language</TableCell>
                  <TableCell align="center" sx={{ minWidth: '8vw', fontWeight: 900 }}>Campaign</TableCell>
                  <TableCell align="center" sx={{ minWidth: '8vw', fontWeight: 900 }}>Battery</TableCell>
                  <TableCell align="center" sx={{ minWidth: '12vw', fontWeight: 900 }}>Messages Delivered/Received</TableCell>
                  <TableCell align="center" sx={{ minWidth: '10vw', fontWeight: 900 }}>Notification Missed</TableCell>
                  <TableCell align="center" sx={{ minWidth: '10vw', fontWeight: 900 }}>Reboot Count</TableCell>
                  <TableCell align="center" sx={{ minWidth: '12vw', fontWeight: 900 }}>Installation Date</TableCell>
                  <TableCell align="center" sx={{ minWidth: '10vw', fontWeight: 900 }}>FW Version</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {devicesList?.map((row) => {
                  const isItemSelected = isSelected(row?.deviceid);
                  return (
                    <TableRow
                      key={row?.deviceid}
                      hover
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      onClick={(event) => handleRowSelectClick(event, row?.deviceid)}
                      input type="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      selected={isItemSelected}
                    >
                      <TableCell padding="checkbox">
                        <Checkbox checked={isItemSelected} />
                      </TableCell>


                      <TableCell className="merchantTableListLabel" component="th" scope="row" >
                        <RouterLink
                          to="/dashboard/soundboxdevicedetails"
                          state={{ deviceId: row?.deviceid, organizationId: row?.organization_id }} >
                          {crossMarkString(row?.merchantid)}
                        </RouterLink>

                      </TableCell>
                      <TableCell className="merchantTableListLabel"  >{crossMarkDeviceIdString(row?.deviceid)}</TableCell>
                      <TableCell className="merchantTableListLabel" >

                        {row?.devicestatus}

                      </TableCell>
                      <TableCell className="merchantTableListLabel" >   {showFieldValueWithCheck(row?.lastpaymentamount)} </TableCell>
                      <TableCell className="merchantTableListLabel" >   {showFieldValueWithCheck(row?.rentstatus)} </TableCell>
                      <TableCell className="merchantTableListLabel" >   {showFieldValueWithCheck(row?.onboardingchannel)} </TableCell>
                      <TableCell className="merchantTableListLabel" >   {showFieldValueWithCheck(row?.zonename)} </TableCell>
                      <TableCell className="merchantTableListLabel" >   {showFieldValueWithCheck(isoDateFToNow(row?.lastpaymentdate))}  </TableCell>
                      <TableCell className="merchantTableListLabel" >   {showFieldValueWithCheck(crossMarkString(row?.sim))} </TableCell>
                      <TableCell className="merchantTableListLabel" >   {showLanguageLabelUsingCode(row?.language)} </TableCell>
                      <TableCell className="merchantTableListLabel" >   {showFieldValueWithCheck(row?.campaign)} </TableCell>
                      <TableCell className="merchantTableListLabel"  >
                        {
                          row?.battery !== null && row?.battery !== undefined ?

                            <Stack direction="row" alignItems="center" spacing={1} justifyContent="center">
                              <Card sx={{ width: "10px", height: "10px", backgroundColor: getColorAccordingSevertity(row.battery) }} />
                              <Typography > {row?.battery} %</Typography>
                            </Stack>
                            :
                            <Typography >-----</Typography>

                        }
                      </TableCell>
                      <TableCell className="merchantTableListLabel" > {showFieldValueWithCheck(row?.message_delivered)}/{showFieldValueWithCheck(row?.message_received)}</TableCell>
                      <TableCell className="merchantTableListLabel" >{showFieldValueWithCheck(row?.notification_missed)}</TableCell>
                      <TableCell className="merchantTableListLabel" >{showFieldValueWithCheck(row?.reboot_count)}</TableCell>
                      <TableCell className="merchantTableListLabel" >{isoDateFormatInDmyhs(row?.installatiodate)} </TableCell>
                      <TableCell className="merchantTableListLabel" >{showFieldValueWithCheck(crossMarkString(row?.fw_version))} </TableCell>



                      <TableCell className="merchantTableListLabel"  >
                        <SoundBoxDeviceMoreMenu handleUser={row} handleClicks={(e) => handleUserMoreMenuClick(e, row)} />
                      </TableCell>



                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>

          {devicesListLoading ?
            <LinearProgress color="success" /> : null
          }
        </Card>
      </Box>

      <TestSoundBoxPaymentModal soundboxDeviceListData={devicesList} selectedDeviceId={selectedDeviceIdForTestPaymnt} opneAssignedModal={isTestSoundBoxModalOpen} handleClose={() => setIsTestSoundBoxModalOpen(false)} onAction={(d) => onTestSoundBoxPaymentModalAction(d)} />
      <ActivateDeviceModal opneAssignedModal={isActivateDeviceModalOpen} handleClose={() => setIsActivateDeviceModalOpen(false)} onAction={(d) => onAddDeviceModalAction(d)} deviceData={selectedDeviceIdForTestPaymnt} />


    </Box>
  );
}
